<template>
    <div>
        <DataTable :headers="headers" :path="path" actionButtonsName="LiquidacionJugadorActionButtons" :properties="properties" filter
                   toolbar toolbar-title="Reporte Mensual de Salarios" search-text="Buscar por título, observación o período" :filter-path="filterPath"></DataTable>
        <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newLiquidacionJugadores">
            <v-icon>add</v-icon>
        </v-btn>
    </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

const CLUB_INDEX_IN_TABLE = 2

export default {
  components: {
    DataTable
  },

  data () {
    return {
      path: 'settlementsplayers',
      filterPath: 'filters/settlement'
    }
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddLiquidacionesjugadores
    },
    headers () {
      let headers = [
        { text: 'Fecha', value: 'fecha', align: 'left' },
        { text: 'Período', value: 'period', align: 'left' },
        { text: 'Título', value: 'title', align: 'left' },
        { text: 'Observación', sortable: false, value: 'description', align: 'left' },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(CLUB_INDEX_IN_TABLE, 0, { text: 'Club', value: 'club', align: 'left', sortable: false, filterField: true })
      }
      return headers
    },
    properties () {
      let properties = ['fecha', 'period', 'title', 'description']
      if (this.$store.getters.isSafRole) {
        properties.splice(CLUB_INDEX_IN_TABLE, 0, 'club')
      }
      return properties
    }
  },

  methods: {
    newLiquidacionJugadores () {
      this.$router.push({ name: 'nuevaLiquidacionJugador' })
    }
  }
}
</script>
